import React from 'react';
import PropTypes from 'prop-types';

const NotFound = ({ message = 'Página no encontrada', showGoBackButton = true }) => {
  return (
    <div className="bg-black flex h-full w-full flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-8">
        <img
          src="/assets/images/logo-desktop.png"
          alt="Clínica Cayetano Heredia"
          className="h-16 w-auto object-contain"
        />
        <div className="text-center">
          <h4 className="text-white text-lg mb-2">{message}</h4>
          <p className="text-gray-400 text-sm">
            La página solicitada no existe
          </p>
        </div>
        <footer className="mt-4 flex items-center justify-center gap-4">
          <span className="text-primary text-xs">2026 Clínica Cayetano Heredia</span>
          <span className="text-gray-600">|</span>
          <a
            href="https://davix.ai/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-primary text-xs text-gray-400 transition-colors duration-200"
          >
            powered by Davix
          </a>
        </footer>
      </div>
    </div>
  );
};

NotFound.propTypes = {
  message: PropTypes.string,
  showGoBackButton: PropTypes.bool,
};

export default NotFound;
